<template>
  <a-modal
    wrapClassName="customModal"
    v-model="showModal"
    :title="title"
    @ok="saveClassRoom"
    :width="width"
    cancelText="取消"
    okText="确定"
    :confirmLoading="submitLoading"
    :afterClose="afterClose"
    :destroyOnClose="true"
    :footer="null"
  >
    <a-form :form="form" :colon="false" layout="vertical" :label-col="labelCol">
      <!-- 关联直播 -->
      <a-form-item label="关联直播">
          <a-radio checked>关联直播</a-radio>
      </a-form-item>
      <!-- 过滤条件 -->
      <div style="display: flex; margin-bottom: 0px">
        <a-form-item label="" style="width: 320px;margin-bottom: 0px">
          <a-select
            mode="multiple"
            v-decorator="['schoolId']"
            placeholder="选择学校"
            showSearch
            optionFilterProp="children"
            @change="handleSchoolChange"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            :maxTagCount="2"
          >
            <a-select-option
              v-for="item in schoolList"
              :key="item.id"
              :value="item.schoolId"
            >
              {{ item.schoolName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="" style="width: 320px; margin-left: 16px">
          <a-range-picker
            @change="handleDateChange"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          />
        </a-form-item>
        <a-form-item label="" style="width: 200px; margin-left: 16px">
          <a-input
            style="width: 100%"
            placeholder="请输入直播名称或关键字"
            autocomplete="off"
            v-decorator="[
              'courseName',
              {
                rules: [{ max: 20, message: '标题不超过20个字' }],
              },
            ]"
            :maxLength="50"
            allowClear
            @keyup.native.enter.stop.prevent="reGetLiveLive"
          />
        </a-form-item>
      </div>
      <!-- 弹框列表 -->
      <a-table
        class="slice-model-table"
        :columns="columns"
        :data-source="liveList"
        :pagination="false"
        :row-key="(record, index) => record.liveId"
        :loading="tabLoading"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
      >
      <template slot="liveName" slot-scope="text, record">
        <span class="live-name-columns">{{ record.liveName }}</span>
      </template>
      <template slot="liveStatus" slot-scope="text, record">
        <a-tag :color="record.liveStatus | filterActiveListStatusTag">{{
          text
        }}</a-tag>
      </template>
      <template slot="schoolNameAndClassName" slot-scope="text, record">
        <span class="school-name-columns">{{ record.schoolNameAndClassName }}</span>
      </template>
      </a-table>
      <!-- 直播数和分页 -->
      <a-row
        type="flex"
        justify="center"
        class="pagination"
      >
        <div>已选直播数:（<span>{{selectedRowKeys.length}}</span>）</div>
        <a-pagination
          v-show="totalCount != 0"
          show-quick-jumper
          show-size-changer
          :default-current="1"
          :total="totalCount"
          :defaultPageSize="5"
          :pageSizeOptions="['5', '10', '20']"
          v-model="pageNum"
          :pageSize.sync="pageSize"
          @change="handlePageChange"
          @showSizeChange="onShowSizeChange"
        />
      </a-row>
      <!-- 按钮 -->
      <div class="btn_box">
        <a-button
          type="default"
          style="margin-right: 16px"
          class="ZHIHUISHU_QZMD"
          @click="closeModal"
        >
          取消
        </a-button>
        <a-button
          @click="saveClassRoom"
          type="primary"
          class="add_course_btn ZHIHUISHU_QZMD"
        >
          确定保存
        </a-button>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
import moment from 'moment'
const columns = [
  {
    title: '直播名称',
    align: 'center',
    dataIndex: 'liveName',
    scopedSlots: { customRender: 'liveName' },
    width: '200px'
  },
  {
    title: 'ID',
    dataIndex: 'liveId',
    scopedSlots: { customRender: 'liveId' },
  },
  {
    title: '状态',
    dataIndex: 'liveStatus',
    scopedSlots: { customRender: 'liveStatus' },
  },
  {
    title: '主讲学校-教室',
    dataIndex: 'schoolNameAndClassName',
    scopedSlots: { customRender: 'schoolNameAndClassName' },
    width: '220px'
  },
  {
    title: '直播时间',
    dataIndex: 'actualStartTime',
    scopedSlots: { customRender: 'actualStartTime' },
  },
]

export default {
  props: {
    title: {
      type: String,
      default: () => '创建活动',
    },
    width: {
      type: Number,
      default: () => 932,
    },
    showModalProp: {
      type: Boolean,
      default: () => false,
    }
  },
  filters: {
    filterActiveListStatusTag(liveStatus) {
      let res = 'blue'
      switch (String(liveStatus)) {
        case '未开始':
          res = 'blue'
          break
        case '进行中':
          res = 'green'
          break
        case '已结束':
          res = 'orange'
          break
      }
      return res
    }
  },
  watch: {
    showModalProp(newVal, oldVal) {
      this.showModal = newVal
      if (newVal) {
        this.reGetLiveLive()
        this.getSchoolList()
        this.getAssociateLiveIds()
      }
    },
  },
  data() {
    return {
      labelCol: { span: 2 },
      showModal: false,
      submitLoading: false,
      form: this.$form.createForm(this, { name: 'form' }),
      columns,
      liveList: [],
      tabLoading: false,
      totalCount: 0,
      pageNum: 1,
      pageSize: 5,
      activeType: 1,
      schoolList: [],
      selectedRowKeys: [],
      startTime: '',
      endTime: '',
      schoolCodes: [],
      selectSchoolId: '',
      schoolId: []
    }
  },
  methods: {
    handleDateChange(date, dateString) {
      this.startTime = dateString[0]
      this.endTime = dateString[1]
      this.reGetLiveLive()
    },
    momentTime(time, format) {
      return moment(time, format)
    },
    handleSelectSchoolChange(value) {
      this.selectSchoolId = value
    },
    handleSchoolChange(value, option) {
      this.schoolCodes = value
      this.reGetLiveLive()
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handleChangeRadio(e) {
      this.activeType = e.target.value
    },
    handlePageChange(page, pageSize) {
      this.pageNum = page
      this.pageSize = pageSize
      this.getLiveLive()
    },
    onShowSizeChange(current, size) {
      this.pageNum = current
      this.pageSize = size
      this.getLiveLive()
    },
    async getAssociateLiveIds() {
      let res = await this.$http.associateLiveIds()
      if (res.code !== 200) {
        return this.$message.error(res.msg || '已选直播数获取失败')
      }
      this.selectedRowKeys = res.rt?.liveIds ?? []
    },
    async getSchoolList() {
      // 初始化各项的值
      try {
        let schoolRes = await this.$http.getSelectSchoolList()
        if (schoolRes.code !== 200) {
          throw '初始化学校失败!请稍候重试'
        } else {
          this.schoolList = schoolRes.rt || []
        }
      } catch (error) {
        // this.$message.error(error)
      }
    },
    reGetLiveLive() {
      this.pageNum = 1
      this.getLiveLive()
    },
    async getLiveLive() {
      try {
        let startTime = this.startTime
        let endTime = this.endTime
        let schoolId = this.schoolCodes
        let courseName = this.form.getFieldValue('courseName')
        let link = ""
        let params = {
          startTime,
          endTime,
          schoolCode: schoolId.join(','),
          liveName: courseName,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
        this.tabLoading = true
        let res = await this.$http.contactList(params)
        this.tabLoading = false
        if (res.code != 200 || res.rt.resultStatus != 1) return this.$message.error(res.rt.resultMessage || '获取活动列表失败')
        res.rt.list?.map(v => {
          link = (v.schoolName && v.classroomName) ? "-" : ""
          v.liveStatus = v.liveStatus == 0 ? "未开始" : (v.liveStatus == 1 ? "进行中" : "已结束")
          v.schoolNameAndClassName = (v.schoolName ? v.schoolName : "") + link + (v.classroomName ? v.classroomName : "")
          v.schoolNameAndClassName = v.schoolNameAndClassName ? v.schoolNameAndClassName : ' '
          link = ""
        })
        this.liveList = res.rt.list || []
        console.log('liveList', this.liveList);
        this.totalCount = res.rt.totalCount
      } catch (error) {
        console.log(error);
      }
    },
    saveClassRoom() {
      this.form.validateFields(async (error, values) => {
        if (!error) {
          let params = {
            liveIds: this.selectedRowKeys.join(',')
          }
          let res = await this.$http.associateLive(params)
          if (res.code != 200 || res.rt.resultStatus != 1) 
          return this.$message.error(res.rt.resultMessage || '保存失败')
          this.$message.success('保存成功')
          this.showModal = false
          this.$emit('refresh')
          this.$emit('close')
        }
      })
    },
    closeModal() {
      this.showModal = false
      this.selectedRowKeys = []
      this.schoolCodes = []
      this.$emit('close')
    },
    afterClose() {
      this.closeModal()
    },
  },
}
</script>

<style lang="scss" scoped>
.slice-model-table {
  width: 884px;
  max-height: 330px;
  overflow-y: auto;
}
::v-deep {
  .ant-form-item {
    margin-bottom: 12px;
  }
  .ant-table-thead {
    height: 54px;
  }
  .ant-radio-checked {
    .ant-radio-inner {
      border-color: #5f60d3;
      &::after {
        background-color: #5f60d3;
      }
    }
  }
  .ant-checkbox-checked {
    .ant-checkbox-inner {
      border-color: #5f60d3;
      background-color: #5f60d3;
      &::after {
        background-color: #5f60d3;
      }
    }
  }
  .ant-checkbox-indeterminate {
    .ant-checkbox-inner {
      &::after {
        background-color: #5f60d3;
      }
    }
  }
  .ant-pagination-item-active {
    border-color: #5f60d3;
    a {
      color: #5f60d3;
    }
  }
  .live-name-columns {
    display: inline-block;
    width: 168px;
    overflow: hidden; 
    text-overflow: ellipsis; 
    white-space: nowrap;
  }
  .school-name-columns {
    display: inline-block;
    width: 188px;
    overflow: hidden; 
    text-overflow: ellipsis; 
    white-space: nowrap;
  }
}
.blank {
  height: 424.45px;
}
.pagination {
  margin-top: 30px;
  position: relative;
  div {
    position: absolute;
    left: 0;
    top: 4px;
    span {
      color: #5f60d3;
    }
  }
}
.btn_box {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  button:nth-child(1) {
    width: 104px;
    height: 38px;
    border-radius: 4px;
    border: 1px solid #5f60d3;
    &:hover {
      color: #5f60d3;
    }
  }
  button:nth-child(2) {
    width: 104px;
    height: 38px;
    background: #5f60d3;
    border-radius: 4px;
    border: none;
  }
}
</style>